module.exports = __webpack_public_path__ + "media/adenomatous polyp.b741de46.wav";